// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_5z5Lg clearfix","businessNewAd1":"index_businessNewAd1_1I4ce","throughColumnAd1":"index_throughColumnAd1_FD9XV"};